<template>
  <div id="app">
    <transition>
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  data(){
    return {}
  },
  methods: {
    handleWindowResize() {
      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
  },
  mounted() {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    if(/iP(hone|ad)/.test(window.navigator.userAgent)) {
      document.body.addEventListener('touchstart', function() {}, false);
    }
  },
  async created() {
    document.documentElement.setAttribute('dir', 'ltr')
    window.addEventListener('resize', this.handleWindowResize)

  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>

<style lang="scss">
#app {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* reCAPTCHA v3: badge nascosto (informativa testuale presente nei form).
   Usare visibility/opacity e NON display:none, che rompe il widget. */
.grecaptcha-badge {
  visibility: hidden;
  opacity: 0;
}

.recaptcha-notice {
  margin-top: 1rem;
  font-size: 0.75rem;
  line-height: 1.4;
  color: #6c757d;
}

.recaptcha-notice a {
  color: inherit;
  text-decoration: underline;
}
</style>